// import { Box, Flex, Text } from "@chakra-ui/react";
// import Card from "components/card/Card.js";
// import React, { useState, useEffect, useMemo } from "react";
// import ReactApexChart from "react-apexcharts";

// export default function Mensal({ data = [], anos }) {
//   const [barChart, setBarChart] = useState([]);
//   const [ano, setAno] = useState("");

//   useEffect(() => {
//     console.log("anual financeiro", data, anos);
//     setBarChart(Array.isArray(data) ? data : []);
//     setAno(anos || "");
//   }, [data, anos]);

//   const mesesAno = [
//     "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
//     "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
//   ];

//   const formatMoney = (value) => {
//     return Number(value || 0).toLocaleString("pt-BR", {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     });
//   };

//   const { seriesArrayReorganizado, title } = useMemo(() => {
//     let VtotalEntrada = 0;
//     let VtotalSaida = 0;

//     const despesaPago = Array(12).fill(0);
//     const despesaNaoPago = Array(12).fill(0);
//     const receitaPago = Array(12).fill(0);
//     const receitaNaoPago = Array(12).fill(0);
//     const despesaVencida = Array(12).fill(0);
//     const receitaVencida = Array(12).fill(0);

//     barChart.forEach((dado) => {
//       const mesIndex = mesesAno.indexOf(dado.Mes);
//       if (mesIndex === -1) return;

//       const vpago = Number(dado.vpago || 0);
//       let vVencido = Number(dado.vVencido || 0);



//       if (dado.Despesa) {
//         const totalDespesa = Number(dado.vSaida || 0);
//         const naoPago = Math.max(totalDespesa - vpago, 0);

//         despesaPago[mesIndex] += vpago;
//         despesaNaoPago[mesIndex] += naoPago;
//         despesaVencida[mesIndex] += vVencido * -1;

//         VtotalSaida += totalDespesa;
//       } else {
//         const totalReceita = Number(dado.vEntrada || 0);
//         const naoPago = Math.max(totalReceita - vpago, 0);

//         receitaPago[mesIndex] += vpago;
//         receitaNaoPago[mesIndex] += naoPago;
//         receitaVencida[mesIndex] += vVencido * -1;

//         VtotalEntrada += totalReceita;
//       }
//     });

//     return {
//       seriesArrayReorganizado: [
//         { name: "Despesa - Pago", group: "despesa", data: despesaPago },
//         { name: "Despesa - Não pago", group: "despesa", data: despesaNaoPago },
//         { name: "Receita - Pago", group: "receita", data: receitaPago },
//         { name: "Receita - Não pago", group: "receita", data: receitaNaoPago },
//         { name: "Despesa vencida", group: "despesa", data: despesaVencida },
//         { name: "Receita vencida", group: "receita", data: receitaVencida },
//       ],
//       title:
//         `${ano} - Total Receitas R$${formatMoney(VtotalEntrada)}` +
//         ` | Total Despesas R$${formatMoney(VtotalSaida)}`,
//     };
//   }, [barChart, ano]);

//   const options = {
//     chart: {
//       type: "bar",
//       height: 500,
//       stacked: true,
//       stackType: "normal",
//       toolbar: {
//         show: true,
//       },
//       zoom: {
//         enabled: false,
//       },
//     },

//     title: {
//       text: title,
//       align: "center",
//       margin: 10,
//       style: {
//         fontSize: "17px",
//         fontWeight: "bold",
//         color: "white",
//       },
//     },

//     colors: [
//       "#00D68F",
//       "#FFB020",
//       "#0095FF",
//       "#805AD5",
//       "#FF3D71",
//       "#F56565",
//     ],

//     plotOptions: {
//       bar: {
//         horizontal: false,
//         columnWidth: "90%",
//         borderRadius: 3,
//       },
//     },

//     dataLabels: {
//       enabled: false,
//     },

//     tooltip: {
//       theme: "dark",
//       enabled: true,
//       shared: false,
//       intersect: true,
//       followCursor: false,

//       custom: function ({ seriesIndex, dataPointIndex, w }) {
//         const mes = mesesAno[dataPointIndex];
//         const serieAtual = w.config.series[seriesIndex];
//         const nomeAtual = serieAtual.name;
//         const grupoAtual = serieAtual.group;

//         const getValue = (name) => {
//           const serie = w.config.series.find((s) => s.name === name);
//           return serie ? Number(serie.data[dataPointIndex] || 0) : 0;
//         };

//         const linha = (label, value, color) => `
//       <div style="display:flex;align-items:center;justify-content:space-between;gap:24px;margin:4px 0;">
//         <span style="display:flex;align-items:center;gap:7px;">
//           <span style="width:10px;height:10px;border-radius:2px;background:${color};display:inline-block;"></span>
//           ${label}
//         </span>
//         <strong>R$ ${formatMoney(Math.abs(value))}</strong>
//       </div>
//     `;

//         if (grupoAtual === "despesa") {
//           const pago = getValue("Despesa - Pago");
//           const naoPago = getValue("Despesa - Não pago");
//           const valor = getValue("Despesa vencida");
//           const total = pago + naoPago;

//           return `
//         <div style="padding:10px 12px;background:#111827;color:#fff;min-width:280px;border-radius:6px;">
//           <div style="font-weight:bold;font-size:14px;margin-bottom:8px;">${mes} - Despesa</div>
//           ${linha("Total", total, "#FFFFFF")}
//           ${linha("Pago", pago, "#00D68F")}
//           ${linha("Não pago", naoPago, "#FFB020")}
//           ${linha("Despesa vencida", valor, "#FF3D71")}
//         </div>
//       `;
//         }

//         if (grupoAtual === "receita") {
//           const pago = getValue("Receita - Pago");
//           const naoPago = getValue("Receita - Não pago");
//            const valor = getValue("Receita vencida");
//           const total = pago + naoPago;

//           return `
//         <div style="padding:10px 12px;background:#111827;color:#fff;min-width:280px;border-radius:6px;">
//           <div style="font-weight:bold;font-size:14px;margin-bottom:8px;">${mes} - Receita</div>
//           ${linha("Total", total, "#FFFFFF")}
//           ${linha("Pago", pago, "#0095FF")}
//           ${linha("Não pago", naoPago, "#805AD5")}
//           ${linha("Receita vencida", valor, "#F56565")}
//         </div>
//       `;
//         }

//         const valorAtual = Number(serieAtual.data[dataPointIndex] || 0);

//         return `
//       <div style="padding:10px 12px;background:#111827;color:#fff;min-width:260px;border-radius:6px;">
//         <div style="font-weight:bold;font-size:14px;margin-bottom:8px;">${mes}</div>
//         ${linha(nomeAtual, valorAtual, "#FFFFFF")}
//       </div>
//     `;
//       },
//     },

//     stroke: {
//       show: true,
//       width: 2,
//       colors: ["transparent"],
//     },

//     xaxis: {
//       categories: mesesAno,
//       labels: {
//         style: {
//           colors: "white",
//           fontSize: "12px",
//           fontWeight: 600,
//         },
//       },
//     },

//     yaxis: {
//       show: true,
//       labels: {
//         formatter: function (value) {
//           return "R$ " + formatMoney(value);
//         },
//         style: {
//           colors: "white",
//         },
//       },
//     },

//     legend: {
//       position: "bottom",
//       labels: {
//         colors: "white",
//       },
//       fontSize: "12px",
//       markers: {
//         width: 12,
//         height: 12,
//         radius: 3,
//       },
//     },

//     fill: {
//       opacity: 1,
//     },

//     grid: {
//       borderColor: "rgba(255,255,255,0.25)",
//     },
//   };

//   return (
//     <Card bg="#0B0B61" align="center" direction="column" w="100%">
//       <Flex align="center" w="100%" px="15px" py="10px">
//         <Text
//           me="auto"
//           color="white"
//           fontSize="xl"
//           fontWeight="700"
//           lineHeight="100%"
//         >
//           Fluxo de Caixa Anual
//         </Text>
//       </Flex>

//       <Box h="450px" mt="auto" w="100%">
//         <ReactApexChart
//           options={options}
//           series={seriesArrayReorganizado}
//           type="bar"
//           width="100%"
//           height="100%"
//         />
//       </Box>
//     </Card>
//   );
// }

import { Box, Flex, Text } from "@chakra-ui/react";
import Card from "components/card/Card.js";
import React, { useState, useEffect, useMemo } from "react";
import ReactApexChart from "react-apexcharts";

export default function Mensal({ data = [], anos }) {
  const [barChart, setBarChart] = useState([]);
  const [ano, setAno] = useState("");

  useEffect(() => {
    console.log("anual financeiro", data, anos);
    setBarChart(Array.isArray(data) ? data : []);
    setAno(anos || "");
  }, [data, anos]);

  const mesesAno = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];

  const formatMoney = (value) => {
    return Number(value || 0).toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const COLORS = {
    despesaPago: "#EF4444",
    despesaNaoPago: "#F97316",
    receitaPago: "#22C55E",
    receitaNaoPago: "#84CC16",
    despesaVencida: "#991B1B",
    receitaVencida: "#166534",
  };

  const { seriesArrayReorganizado, title } = useMemo(() => {
    let VtotalEntrada = 0;
    let VtotalSaida = 0;

    const despesaPago = Array(12).fill(0);
    const despesaNaoPago = Array(12).fill(0);
    const receitaPago = Array(12).fill(0);
    const receitaNaoPago = Array(12).fill(0);
    const despesaVencida = Array(12).fill(0);
    const receitaVencida = Array(12).fill(0);

    barChart.forEach((dado) => {
      const mesIndex = mesesAno.indexOf(dado.Mes);
      if (mesIndex === -1) return;

      const vpago = Number(dado.vpago || 0);
      const vVencido = Number(dado.vVencido || 0);

      if (dado.Despesa) {
        const totalDespesa = Number(dado.vSaida || 0);
        const naoPago = Math.max(totalDespesa - vpago, 0);

        despesaPago[mesIndex] += vpago;
        despesaNaoPago[mesIndex] += naoPago;
        despesaVencida[mesIndex] += vVencido * -1;

        VtotalSaida += totalDespesa;
      } else {
        const totalReceita = Number(dado.vEntrada || 0);
        const naoPago = Math.max(totalReceita - vpago, 0);

        receitaPago[mesIndex] += vpago;
        receitaNaoPago[mesIndex] += naoPago;
        receitaVencida[mesIndex] += vVencido * -1;

        VtotalEntrada += totalReceita;
      }
    });

    return {
      seriesArrayReorganizado: [
        { name: "Despesa - Pago", group: "despesa", data: despesaPago },
        { name: "Despesa - Não pago", group: "despesa", data: despesaNaoPago },
        { name: "Receita - Pago", group: "receita", data: receitaPago },
        { name: "Receita - Não pago", group: "receita", data: receitaNaoPago },
        { name: "Despesa vencida", group: "despesa", data: despesaVencida },
        { name: "Receita vencida", group: "receita", data: receitaVencida },
      ],
      title:
        `${ano} - Total Receitas R$${formatMoney(VtotalEntrada)}` +
        ` | Total Despesas R$${formatMoney(VtotalSaida)}`,
    };
  }, [barChart, ano]);

  const options = {
    chart: {
      type: "bar",
      height: 500,
      stacked: true,
      stackType: "normal",
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: false,
      },
      foreColor: "#FFFFFF",
    },

    title: {
      text: title,
      align: "center",
      margin: 10,
      style: {
        fontSize: "17px",
        fontWeight: "bold",
        color: "white",
      },
    },

    colors: [
      COLORS.despesaPago,
      COLORS.despesaNaoPago,
      COLORS.receitaPago,
      COLORS.receitaNaoPago,
      COLORS.despesaVencida,
      COLORS.receitaVencida,
    ],

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "72%",
        borderRadius: 4,
        borderRadiusApplication: "end",
        dataLabels: {
          position: "center",
        },
      },
    },

    dataLabels: {
      enabled: true,
      formatter: function (value, opts) {
        if (!value || Number(value) === 0) return "";

        const serie = opts.w.config.series[opts.seriesIndex];
        const isReceita = serie.group === "receita";

        return isReceita ? "+" : "-";
      },
      style: {
        fontSize: "13px",
        fontWeight: "bold",
        colors: ["#FFFFFF"],
      },
      background: {
        enabled: false,
      },
      dropShadow: {
        enabled: true,
        top: 1,
        left: 1,
        blur: 2,
        opacity: 0.45,
      },
    },

    tooltip: {
      theme: "dark",
      enabled: true,
      shared: false,
      intersect: true,
      followCursor: false,

      custom: function ({ seriesIndex, dataPointIndex, w }) {
        const mes = mesesAno[dataPointIndex];
        const serieAtual = w.config.series[seriesIndex];
        const nomeAtual = serieAtual.name;
        const grupoAtual = serieAtual.group;

        const getValue = (name) => {
          const serie = w.config.series.find((s) => s.name === name);
          return serie ? Number(serie.data[dataPointIndex] || 0) : 0;
        };

        const linha = (label, value, color) => `
          <div style="display:flex;align-items:center;justify-content:space-between;gap:24px;margin:4px 0;">
            <span style="display:flex;align-items:center;gap:7px;">
              <span style="width:10px;height:10px;border-radius:2px;background:${color};display:inline-block;"></span>
              ${label}
            </span>
            <strong>R$ ${formatMoney(Math.abs(value))}</strong>
          </div>
        `;

        if (grupoAtual === "despesa") {
          const pago = getValue("Despesa - Pago");
          const naoPago = getValue("Despesa - Não pago");
          const valor = getValue("Despesa vencida");
          const total = pago + naoPago;

          return `
            <div style="padding:10px 12px;background:#111827;color:#fff;min-width:280px;border-radius:6px;">
              <div style="font-weight:bold;font-size:14px;margin-bottom:8px;">${mes} - Despesa</div>
              ${linha("Total", total, "#FFFFFF")}
              ${linha("Pago", pago, COLORS.despesaPago)}
              ${linha("Não pago", naoPago, COLORS.despesaNaoPago)}
              ${linha("Despesa vencida", valor, COLORS.despesaVencida)}
            </div>
          `;
        }

        if (grupoAtual === "receita") {
          const pago = getValue("Receita - Pago");
          const naoPago = getValue("Receita - Não pago");
          const valor = getValue("Receita vencida");
          const total = pago + naoPago;

          return `
            <div style="padding:10px 12px;background:#111827;color:#fff;min-width:280px;border-radius:6px;">
              <div style="font-weight:bold;font-size:14px;margin-bottom:8px;">${mes} - Receita</div>
              ${linha("Total", total, "#FFFFFF")}
              ${linha("Pago", pago, COLORS.receitaPago)}
              ${linha("Não pago", naoPago, COLORS.receitaNaoPago)}
              ${linha("Receita vencida", valor, COLORS.receitaVencida)}
            </div>
          `;
        }

        const valorAtual = Number(serieAtual.data[dataPointIndex] || 0);

        return `
          <div style="padding:10px 12px;background:#111827;color:#fff;min-width:260px;border-radius:6px;">
            <div style="font-weight:bold;font-size:14px;margin-bottom:8px;">${mes}</div>
            ${linha(nomeAtual, valorAtual, "#FFFFFF")}
          </div>
        `;
      },
    },

    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },

    xaxis: {
      categories: mesesAno,
      labels: {
        style: {
          colors: "white",
          fontSize: "12px",
          fontWeight: 600,
        },
      },
      axisBorder: {
        color: "rgba(255,255,255,0.25)",
      },
      axisTicks: {
        color: "rgba(255,255,255,0.25)",
      },
    },

    yaxis: {
      show: true,
      labels: {
        formatter: function (value) {
          return "R$ " + formatMoney(value);
        },
        style: {
          colors: "white",
        },
      },
    },

    legend: {
      position: "bottom",
      labels: {
        colors: "white",
      },
      fontSize: "12px",
      markers: {
        width: 12,
        height: 12,
        radius: 3,
      },
    },

    fill: {
      opacity: 1,
    },

    grid: {
      borderColor: "rgba(255,255,255,0.18)",
    },
  };

  return (
    <Card bg="#0B0B61" align="center" direction="column" w="100%">
      <Flex align="center" w="100%" px="15px" py="10px">
        <Text
          me="auto"
          color="white"
          fontSize="xl"
          fontWeight="700"
          lineHeight="100%"
        >
          Fluxo de Caixa Anual
        </Text>
      </Flex>

      <Box h="450px" mt="auto" w="100%">
        <ReactApexChart
          options={options}
          series={seriesArrayReorganizado}
          type="bar"
          width="100%"
          height="100%"
        />
      </Box>
    </Card>
  );
}